import { render, staticRenderFns } from "./CountrySalesPerWeekTable.vue?vue&type=template&id=62b71d9c&"
import script from "./CountrySalesPerWeekTable.vue?vue&type=script&lang=js&"
export * from "./CountrySalesPerWeekTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports